//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UnStepComponent',
  props: {
    activeStep: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    computedSteps() {
      const steps = []
      for (let i = 1; i <= this.totalSteps; i++) {
        steps.push({
          number: i.toString(),
          active: i <= this.activeStep,
        })
      }
      return steps
    },
  },
}
